<template>
  <div v-for="point in points" :key="point" class="list-item">
    <span class="mdi mdi-circle-medium mr-2"></span> {{ point }}
  </div>
</template>
<script>
export default {
  name: 'DottedList',
  props: {
    points: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss"></style>
